import { Attribute } from './Attribute.js';

export const LICENCE_COUNT_ATTRIBUTE_TYPE = 'LicenceCountAttribute';
export const LICENCE_COUNT_ATTRIBUTE_ID = 'licence_count';

/**
 * Represents `Amount` attribute parsed without options.
 * This is renamed attribute ID on OST site from `Amount` to `licence_count`.
 * Attribute value is parsed exactly same way as `AmountAttribute`s value.
 *
 *
 * @property {number} value
 * @property {boolean} isReadOnly
 */
export class LicenceCountAttribute extends Attribute {
  constructor({ value, isReadOnly = false }) {
    super();
    this.value = value;
    this.isReadOnly = isReadOnly;
    this.type = LICENCE_COUNT_ATTRIBUTE_TYPE;
  }
}
